import { FreeUseDay } from "../../../constants/General";
import styles from "../mainRedesign.module.scss";

export default () => {
  return (
    <section className={styles.couponBanner}>
      <div className={styles.couponInner}>
        <div className={styles.couponText}>
          <div className={styles.couponTitle}>
            콘엑스 가입시 {FreeUseDay}일 쿠폰 드려요!
          </div>
          <div className={styles.couponDesc}>
            쿠폰은 회원가입과 동시에 자동 적용됩니다.
          </div>
        </div>
        <img
          src="/images/ddusul/3d-coupon2.png"
          alt="쿠폰"
          className={styles.couponImage}
        />
      </div>
    </section>
  );
};
